import { Injectable } from '@angular/core';
import { MessageService, MessagePremVoicesReady, MessageFreeVoicesReady } from './message.service';
import { FreeVoicesService } from './voices-free.service';
import { AppService } from './app.service';
import { UtilVoicesService } from './util-voices.service';

export class PremVoice {
  constructor(
    public key: string,
    public name: string,
    public language: string,
    public languageName: string,
    public source: string,
    public id: string,
    public ready: string,
    public noAuth: boolean,
    public type: string = 'prem'
  ) {
  }
}

@Injectable({
  providedIn: 'root'
})

export class PremVoicesService {
  private voices: Map<string, PremVoice>;

  constructor(
    private messageService: MessageService,
    private freeVoicesService: FreeVoicesService,
    private voiceUtilService: UtilVoicesService
  ) {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      this.voices = new Map<string, PremVoice>();
      this.messageService.getMessage().subscribe(message => {
        if (message.name === MessageFreeVoicesReady) {
          // console.log("free voices for prem voices", this.freeVoicesService.getVoices());
          this.setVoices().then(() => {
            setTimeout(() => {
              this.messageService.sendMessage({ name: MessagePremVoicesReady });
            }, 1000);
          });
        }
      });
    }
  }

  public setVoices(): Promise<any> {
    return Promise.resolve()
      .then(() => {
        this.addVoice('Sharon', 'en-US', 'aca', '21', '1', true);
        this.addVoice('Ryan', 'en-US', 'aca', '12', '1', true);
        this.addVoice('Heather', 'en-US', 'aca', '5', '1', true);
        this.addVoice('Will', 'en-US', 'aca', '26', '1', true);
        this.addVoice('Rod', 'en-US', 'aca', '20', '1');
        this.addVoice('Karen', 'en-US', 'aca', '27', '1');
        this.addVoice('Tracy', 'en-US', 'aca', '16', '1');
        this.addVoice('Mike', 'en-US', 'att', '1', '1');
        this.addVoice('Laura', 'en-US', 'aca', '8', '1');
        this.addVoice('Rachel', 'en-GB', 'aca', '11', '1', true);
        this.addVoice('Peter', 'en-GB', 'aca', '10', '1', true);
        this.addVoice('Lucy', 'en-GB', 'aca', '9', '1', true);
        this.addVoice('Charles', 'en-GB', 'att', '2', '1');
        this.addVoice('Audrey', 'en-GB', 'att', '3', '1');
        this.addVoice('Graham', 'en-GB', 'aca', '4', '1');
        this.addVoice('Tyler', 'en-AU', 'aca', '28', '1', true);
        this.addVoice('Lisa', 'en-AU', 'aca', '29', '1', true);
        this.addVoice('Rosa', 'es-ES', 'att', '20', '1', true);
        this.addVoice('Alberto', 'es-ES', 'att', '19', '1', true);
        this.addVoice('Ines', 'es-ES', 'aca', '30', '1');
        this.addVoice('Maria', 'es-ES', 'aca', '31', '1');
        this.addVoice('Rodrigo', 'es-US', 'aca', '32', '1');
        this.addVoice('Lucia', 'es-US', 'aca', '33', '1');
        this.addVoice('Alain', 'fr-FR', 'att', '7', '1', true);
        this.addVoice('Juliette', 'fr-FR', 'att', '8', '1', true);
        this.addVoice('Bruno', 'fr-FR', 'aca', '1', '1');
        this.addVoice('Alice', 'fr-FR', 'aca', '0', '1');
        this.addVoice('Louise', 'fr-CA', 'aca', '22', '1');
        this.addVoice('Celia', 'pt-PT', 'aca', '23', '1', true);
        this.addVoice('Marcia', 'pt-BR', 'aca', '34', '1', true);
        this.addVoice('Reiner', 'de-DE', 'att', '5', '1', true);
        this.addVoice('Klara', 'de-DE', 'att', '6', '1', true);
        this.addVoice('Klaus', 'de-DE', 'aca', '7', '1');
        this.addVoice('Sarah', 'de-DE', 'aca', '14', '1');
        this.addVoice('Claudia', 'de-DE', 'aca', '35', '1');
        this.addVoice('Andreas', 'de-DE', 'aca', '36', '1');
        this.addVoice('Vittorio', 'it-IT', 'aca', '15', '1', true);
        this.addVoice('Chiara', 'it-IT', 'aca', '2', '1', true);
        this.addVoice('Fabiana', 'it-IT', 'aca', '37', '1', true);
        this.addVoice('Jasmijn', 'nl-NL', 'aca', '38', '1', true);
        this.addVoice('Daan', 'nl-NL', 'aca', '39', '1', true);
        this.addVoice('Emma', 'sv-SE', 'aca', '24', '1', true);
        this.addVoice('Erik', 'sv-SE', 'aca', '25', '1', true);
        this.addVoice('Elin', 'sv-SE', 'aca', '40', '1', true);
        this.addVoice('Emil', 'sv-SE', 'aca', '41', '1', true);
      }).catch(function(err) {
        console.log(err);
      });
  }

  public getVoices() {
    return this.voices;
  }

  public addVoice(name: string, language: string, source: string, id: string, ready: string, noAuth: boolean = false): Promise<any> {
    return Promise.resolve()
      .then(() => {
        let key = name + ' ' + language + ' ' + 'prem';
        let languageLocale = this.voiceUtilService.getLanguageAndLocaleForVoiceList(language)
        if (source === 'google') {
          let googleVoice = this.freeVoicesService.getVoices().get(name + ' ' + language + ' free');
          if (googleVoice && googleVoice.source === 'google') {
            console.log("has google voice", name);
            this.voices.set(key, new PremVoice(key, name, language, languageLocale.languageName, source, id, ready, noAuth));
          } else {
            console.log("no google voice", name);
          }
        } else {
          this.voices.set(key, new PremVoice(key, name, language, languageLocale.languageName, source, id, ready, noAuth));
        }
      }).catch(function(err) {
        console.log(err);
      });
  }
}
